@if (user$ | async; as user) {
  @if (prestatie$ | async; as prestatie) {
    @if (client$ | async; as client) {
      @if (thuisverzorger$ | async; as thuisverzorger) {
        @if (diensten$ | async; as diensten) {
          @if (taakTipAantallen$ | async; as taakTipAantallen) {
            <zah-prestatie-header [prestatie]="prestatie"
              [client]="client"
              [thuisverzorger]="thuisverzorger">
            </zah-prestatie-header>
            <zah-client-diensten [user]="user"
              [client]="client"
              [prestatie]="prestatie"
              [diensten]="diensten"
              [taakTipAantallen]="taakTipAantallen"
              emptyLabel="Er zijn geen uitgevoerde taken voor deze prestatie."
              (meldingenClicked)="navigateToMeldingen(client)"
              (tipsOpened)="navigateToTips(client, $event)">
              <button mat-mini-fab
                color="primary"
                class="back-button"
                (click)="navigateToPrestaties(client)">
                <mat-icon>arrow_back</mat-icon>
              </button>
            </zah-client-diensten>
          }
        }
      }
    }
  }
}
